class PropertySingleGmap {
    constructor() {
        // Get coordinates from the first map container
        const mapContainer = document.querySelector('.c-google_map_cont');
        
        if (!mapContainer) {
            // console.error('Map container not found');
            return;
        }

        // Get coordinates from data attributes
        this.longitude = parseFloat(mapContainer.dataset.longitude);
        this.latitude = parseFloat(mapContainer.dataset.latitude);

        // Get smooth scroll instance from app
        this.smoothScroll = window.app?.components?.smoothScroll;

        // Bind the initMap method to this instance
        this.initMap = this.initMap.bind(this);
        this.renderMap = this.renderMap.bind(this);

        // Add initialization function to window object
        window.initGoogleMaps = this.initMap;
    }

    initMap() {
        // Initialize the default map
        this.renderMap('property-single-map');
        this.renderMap('property-detail-map');
    }

    renderMap(containerId) {
        if (!this.isValidCoordinates()) {
            console.error('Invalid coordinates:', this.latitude, this.longitude);
            return;
        }

        const mapContainer = document.getElementById(containerId);
        const containerWidth = mapContainer.offsetWidth;
        const containerHeight = mapContainer.offsetHeight;
        const viewportWidth = window.innerWidth;

        // Determine if we're on mobile/small screen
        const isMobileView = viewportWidth < 768;

        // Determine zoom level based on container size
        let zoomLevel;
        if (isMobileView) {
            zoomLevel = 12;
        } else {
            zoomLevel = 15;
        }

        const propertyLocation = { lat: this.latitude, lng: this.longitude };

        // Define custom map styles
        const mapStyles = [
            // {
            //     featureType: 'all',
            //     elementType: 'labels.text.fill',
            //     stylers: [
            //         { color: '#7c93a3' },
            //         { lightness: '-10' }
            //     ]
            // },
            {
                featureType: 'administrative.country',
                elementType: 'geometry',
                stylers: [{ visibility: 'on' }]
            },
            {
                featureType: 'administrative.province',
                elementType: 'geometry.stroke',
                stylers: [{ visibility: 'off' }]
            },
            {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                // stylers: [{ color: '#f7f7f7' }]
            },
            {
                featureType: 'poi',
                elementType: 'all',
                stylers: [{ visibility: 'off' }]
            },
            // {
            //     featureType: 'road',
            //     elementType: 'geometry.fill',
            //     stylers: [{ color: '#ffffff' }]
            // },
            // {
            //     featureType: 'road',
            //     elementType: 'geometry.stroke',
            //     stylers: [{ color: '#d6d6d6' }]
            // },
            {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [{ visibility: 'off' }]
            },
            {
                featureType: 'transit',
                elementType: 'all',
                stylers: [{ visibility: 'off' }]
            },
            // {
            //     featureType: 'water',
            //     elementType: 'geometry.fill',
            //     stylers: [{ color: '#e3e3e3' }]
            // }
        ];

         // Function to scale the SVG pin marker
         const scaleMarker = (baseSize, multiplier) => {
            // Original SVG dimensions
            const originalWidth = 17;
            const originalHeight = 23;
            
            // Calculate scaled dimensions
            const width = Math.round(originalWidth * multiplier);
            const height = Math.round(originalHeight * multiplier);
            
            return {
                width,
                height,
                // Anchor at the bottom center of the pin
                anchorX: Math.round(width / 2),
                anchorY: height
            };
        };
        
        // Set scale multiplier based on device
        const multiplier = isMobileView ? 0.8 : 1.2;
        
        // Get scaled dimensions
        const markerDimensions = scaleMarker(1, multiplier);
        
        // Convert your SVG to a data URL for the marker
        const svgPin = `
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="23" viewBox="0 0 17 23" fill="none">
            <path d="M16.6869 8.00973C16.6869 3.58769 12.9551 0 8.34347 0C3.73181 0 0 3.58769 0 8.00973C0 9.52673 0.439928 10.9375 1.19843 12.1435L8.35106 22.7473L15.4961 12.136C16.2546 10.9299 16.6869 9.51914 16.6869 8.00973Z" fill="#F73929"/>
            <path d="M8.34349 11.3926C10.3082 11.3926 11.9008 9.86448 11.9008 7.9794C11.9008 6.09432 10.3082 4.56616 8.34349 4.56616C6.37881 4.56616 4.78613 6.09432 4.78613 7.9794C4.78613 9.86448 6.37881 11.3926 8.34349 11.3926Z" fill="white"/>
        </svg>`;
        
        // Create base64 encoded URL
        const svgEncoded = btoa(svgPin);
        const markerUrl = 'data:image/svg+xml;base64,' + svgEncoded;
        
        // Define custom marker icon
        const customMarker = {
            url: markerUrl,
            // Size of the image
            scaledSize: new google.maps.Size(markerDimensions.width, markerDimensions.height),
            // Point in the icon image at which to anchor the marker
            anchor: new google.maps.Point(markerDimensions.anchorX, markerDimensions.anchorY)
        };


        try {
            const map = new google.maps.Map(mapContainer, {
                zoom: zoomLevel,
                center: propertyLocation,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: false,
                styles: mapStyles
            });

            // Add the marker with custom icon
            new google.maps.Marker({
                position: propertyLocation,
                map: map,
                animation: google.maps.Animation.DROP,
                icon: customMarker
            });

            // Add wheel event listener to pause smooth scrolling when using command/control key
            mapContainer.addEventListener('wheel', (e) => {
                if (e.metaKey || e.ctrlKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Stop smooth scrolling if available
                    if (this.smoothScroll) {
                        this.smoothScroll.stop();
                        // Resume smooth scrolling on next frame
                        requestAnimationFrame(() => {
                            this.smoothScroll.start();
                        });
                    }
                }
            });

            return map;
        } catch (error) {
            console.error('Error initializing map:', error);
        }
    }

    isValidCoordinates() {
        return !isNaN(this.latitude) && 
               !isNaN(this.longitude) && 
               this.latitude !== 0 && 
               this.longitude !== 0;
    }
}

// Export a singleton instance
export const mapInstance = new PropertySingleGmap();
export default PropertySingleGmap;
